<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid style="height: 100%">
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <ion-icon src="/assets/icon/wallet.svg" color="primary"></ion-icon>
      <p>Se cargarán {{ amount | currency }} a tu saldo en Wallet</p>
      <ion-button shape="round" color="primary" expand="block" (click)="pay()">Aceptar</ion-button>
      <ion-button shape="round" color="primary" expand="block" (click)="closeModal()">Cancelar</ion-button>
    </ion-row>
  </ion-grid>
</ion-content>
